import { Menu, X, Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const NAV_LINKS = [
  { id: "problemas", label: "Problemas" },
  { id: "servicio", label: "Servicio" },
  { id: "metodologia", label: "Metodología" },
  { id: "precios", label: "Precios" },
  { id: "mantenimiento", label: "Mantenimiento" },
  { id: "faq", label: "FAQ" },
];

export function Navbar({ scrollToSection, mobileMenuOpen, setMobileMenuOpen }) {
  return (
    <nav className="navbar">
      <div className="container-custom">
        <div className="flex items-center justify-between h-24">
          <a href="#" className="flex items-center gap-3" data-testid="navbar-logo">
            <img src="/logo.png" alt="IA Sanitaria @tecnoabogado" className="h-16 w-auto" />
          </a>

          <div className="hidden md:flex items-center gap-1">
            {NAV_LINKS.map((link) => (
              <button key={link.id} onClick={() => scrollToSection(link.id)} className="nav-link" data-testid={`nav-${link.id}`}>
                {link.label}
              </button>
            ))}
            <a href="https://iasanitaria.es/" target="_blank" rel="noopener noreferrer" className="nav-link" data-testid="nav-blog">Blog</a>
          </div>

          <div className="hidden md:block">
            <Button onClick={() => scrollToSection('diagnostico')} className="btn-primary text-sm" data-testid="nav-cta-button">
              <Lock className="w-4 h-4" />
              Solicitar diagnóstico
            </Button>
          </div>

          <button className="md:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-testid="mobile-menu-toggle">
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-800" data-testid="mobile-menu">
            <div className="flex flex-col gap-2">
              {NAV_LINKS.map((link) => (
                <button key={link.id} onClick={() => scrollToSection(link.id)} className="nav-link text-left" data-testid={`mobile-nav-${link.id}`}>
                  {link.label}
                </button>
              ))}
              <a href="https://iasanitaria.es/" target="_blank" rel="noopener noreferrer" className="nav-link text-left" data-testid="mobile-nav-blog">Blog</a>
              <Button onClick={() => scrollToSection('diagnostico')} className="btn-primary mt-2 w-full" data-testid="mobile-cta-button">
                <Lock className="w-4 h-4" />
                Solicitar diagnóstico
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
